// extracted by mini-css-extract-plugin
module.exports = {"header":"tables-intro_header__1n9oi","welcome":"tables-intro_welcome__17OcO","participant":"tables-intro_participant__2V32W","info":"tables-intro_info__3fW-u"};